module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0,"color":"#198CDB","label":"0.67"},{"quantity":0.001,"color":"#91E3AD","label":"0.67 - 1.66"},{"quantity":0.03,"color":"#DEFFB0","label":"1.66 - 3"},{"quantity":0.06,"color":"#FFE68C","label":"3 - 4.72"},{"quantity":0.1,"color":"#FF9982","label":"4.72 - 7.73"},{"quantity":12,"color":"#FF4D30","label":"7.73 - 12.01"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_rice.json
// module id = NYHs
// module chunks = 171